/**
 * ProfessocialStatistics stellt alle Module zur Verfügung, die für die Statistiken nötig sind
 */

import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'
import statisticColors from '../util/getStatisticColors'

import * as commonActions from '../store/common/common.actions'
import { StatisticConfiguration } from '@professocial/professocialTypes/types/configurationTypes'

import Submenu, { SubmenuData } from '@professocial/professocialFormComponents/FormComponents/Submenu'
import { getTheme, getUser } from '../store/common/common.selectors'
import EditorPageStatistics from './Editor/EditorPageStatistics'
import EditorSortedPosts from './Editor/EditorSortedPosts'
import UserPageStatistics from './User/UserPageStatistics'
import EditorPostingStatistics from './Editor/EditorPostingStatistics'
import { FindPostsSearchType } from '@3m5/sm_publish-frontend-api'

export interface Props {
  statisticConfiguration?: StatisticConfiguration
}

const ProfessocialStatistics: React.FC<Props> = (props) => {
  const dispatch = useDispatch()
  const theme = useSelector(getTheme)
  const { t } = useTranslation()
  const { path } = useRouteMatch()

  const user = useSelector(getUser)

  useEffect(() => {
    props.statisticConfiguration?.theme && dispatch(commonActions.setTheme(props.statisticConfiguration?.theme))
  }, [props.statisticConfiguration?.theme])

  useEffect(() => {
    props.statisticConfiguration?.user && dispatch(commonActions.setUser(props.statisticConfiguration?.user))
  }, [])

  useEffect(() => {
    dispatch(commonActions.setUser(props.statisticConfiguration?.user))
  }, [props.statisticConfiguration?.user])

  const subMenu: SubmenuData[] = [
    {
      id: 'pageStatistics',
      label: t('statisticsCommon:pageStatistics'),
    },
    {
      id: 'postingStatistics',
      label: t('statisticsCommon:postingStatistics'),
    },
    {
      id: 'successfulPosts',
      label: t('statisticsCommon:successfulPosts'),
    },
    {
      id: 'unsuccessfulPosts',
      label: t('statisticsCommon:unsuccessfulPosts'),
    },
  ]

  const userSubMenu: SubmenuData[] = [
    {
      id: 'pageStatistics',
      label: t('statisticsCommon:pageStatistics'),
    },
  ]

  return (
    <>
      <Grid container spacing={2} sx={{ px: 2, pb: 12 }}>
        <Submenu data={user?.role === 'USER' ? userSubMenu : subMenu} />
        <Grid
          xs={12}
          item
          container
          direction='row'
        >
          <Grid container item xs={12}>
            <Switch>
              <Redirect exact from={`${path}`} to={`${path}/pageStatistics`} />
              {user?.role === 'USER' && (
                <>
                  <Route path={`${path}/pageStatistics`}>
                    <UserPageStatistics
                      user={props.statisticConfiguration?.user}
                      colors={statisticColors(theme)}
                      statisticConfiguration={props.statisticConfiguration}
                    />
                  </Route>
                </>
              )}
              {user?.role === 'EDITOR' && (
                <>
                  <Route path={`${path}/pageStatistics`}>
                    <EditorPageStatistics colors={statisticColors(theme)} user={user} />
                  </Route>
                  <Route path={`${path}/postingStatistics`}>
                    <EditorPostingStatistics colors={statisticColors(theme)} user={user} />
                  </Route>
                  <Route path={`${path}/successfulPosts`}>
                    <EditorSortedPosts user={user} type={FindPostsSearchType.BestPosts}/>
                  </Route>
                  <Route path={`${path}/unsuccessfulPosts`}>
                    <EditorSortedPosts user={user} type={FindPostsSearchType.WorstPosts}/>
                  </Route>
                </>
              )}
            </Switch>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
export default ProfessocialStatistics
